import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description: string;
  action?: React.ReactNode;
  className?: string;
}

export function EmptyState({ icon: Icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div className={cn("border border-slate-200 rounded-lg bg-white px-8 py-16 text-center", className)}>
      <div className="mx-auto w-10 h-10 rounded-lg bg-brand-50 flex items-center justify-center mb-4">
        <Icon className="w-5 h-5 text-brand-500" />
      </div>
      <h3 className="text-sm font-semibold text-brand-950 mb-1">{title}</h3>
      <p className="text-sm text-slate-500 max-w-[320px] mx-auto">{description}</p>
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
